/* TK size chart switches.
   1. CM / IN on each table of the size chart layout (snippets/tk-size-chart.liquid), on the page and in the product page's
      size guide drawer that loads it. One choice switches every table in that chart and is remembered for next time.
   2. The old Metric / US tabs (the page's own markup), still used if the page ever falls back to its raw content.
      Ported from the live theme's inline script, with one fix: each chart is set to Metric once, when it first appears
      (the old version reset every chart on any change anywhere in the page, so US could flip back by itself). */
(function () {
  if (window.__tkSizeChart) return;
  window.__tkSizeChart = true;

  var KEY = 'tk_size_unit';

  /* ---------- 1. CM / IN ---------- */
  function setUnit(root, unit) {
    root.querySelectorAll('[data-tksc-unit]').forEach(function (el) {
      el.hidden = el.getAttribute('data-tksc-unit') !== unit;
    });
    root.querySelectorAll('[data-tksc-set]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-tksc-set') === unit ? 'true' : 'false');
    });
  }

  function savedUnit() {
    try {
      var u = localStorage.getItem(KEY);
      return u === 'cm' || u === 'in' ? u : null;
    } catch (e) { return null; }
  }

  /* ---------- 2. old Metric / US tabs ---------- */
  function tabParts(root) {
    return {
      metricTab: root.querySelector('#tk-tab-metric'),
      usTab: root.querySelector('#tk-tab-us'),
      metricPanel: root.querySelector('#tk-panel-metric'),
      usPanel: root.querySelector('#tk-panel-us')
    };
  }

  function showTabs(root, metric) {
    var p = tabParts(root);
    if (!p.metricTab || !p.usTab || !p.metricPanel || !p.usPanel) return;
    p.metricTab.classList.toggle('is-active', metric);
    p.usTab.classList.toggle('is-active', !metric);
    p.metricPanel.hidden = !metric;
    p.usPanel.hidden = metric;
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var unitBtn = event.target.closest('[data-tksc-set]');
    if (unitBtn) {
      var chart = unitBtn.closest('[data-tksc]');
      if (!chart) return;
      var unit = unitBtn.getAttribute('data-tksc-set');
      setUnit(chart, unit);
      try { localStorage.setItem(KEY, unit); } catch (e) {}
      return;
    }

    var tab = event.target.closest('.tk-unit-tab');
    if (!tab) return;
    var root = tab.closest('[data-tk-size-page]');
    if (!root) return;
    showTabs(root, tab.id === 'tk-tab-metric');
  }, true);

  function init() {
    var unit = savedUnit();
    document.querySelectorAll('[data-tksc]:not([data-tksc-ready])').forEach(function (chart) {
      chart.setAttribute('data-tksc-ready', '');
      if (unit) setUnit(chart, unit);
    });
    document.querySelectorAll('[data-tk-size-page]:not([data-tk-size-ready])').forEach(function (root) {
      root.setAttribute('data-tk-size-ready', '');
      showTabs(root, true);
    });
  }

  /* "How to measure" sticks 24px under the site header. With the theme's sticky header on (header.header-is-sticky),
     the header slides back in whenever the shopper scrolls up, so the card always keeps clear of the header's height,
     whether or not it is showing at that moment. The offset goes to the CSS as --tksc-sticky-top. */
  function stickyOffset() {
    var header = document.querySelector('header.site-header.header-is-sticky');
    var section = header && (header.closest('.shopify-section') || header);
    var h = section ? section.offsetHeight : 0;
    document.documentElement.style.setProperty('--tksc-sticky-top', (h + 24) + 'px');
  }
  window.addEventListener('load', stickyOffset);
  window.addEventListener('resize', stickyOffset);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', stickyOffset);
  else stickyOffset();

  /* the size guide drawer adds the chart later, so look again whenever the page changes (batched per frame) */
  var queued = false;
  function queueInit() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; init(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  new MutationObserver(queueInit).observe(document.documentElement, { childList: true, subtree: true });
})();
